var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { IconTextValue, useLang } from '@shapeable/ui';
import { AiLowerCaseIconGlyph } from '@shapeable/icons';
var cls = classNames('explorer-gpt--banner-layout');
export var ExplorerGptBannerLayoutDefaultProps = {
  label: 'Shape AI'
};
// -------- Styles -------->
var BannerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n    border-top: 3px solid ", ";\n    border-radius: 0px 0px 8px 8px;\n    background: ", ";\n  "], ["\n    padding: ", " ", ";\n    border-top: 3px solid ", ";\n    border-radius: 0px 0px 8px 8px;\n    background: ", ";\n  "])), theme.UNIT(5), theme.UNIT(4), theme.COLOR('line-subtle'), theme.COLOR('brightWarm'))
});
var IconHeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    padding-bottom: ", ";\n  "])), theme.FONT_SIZE(32), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Banner: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  IconHeader: styled(IconTextValue)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconHeaderStyles)
};
export var ExplorerGptBannerLayout = function (props) {
  var className = props.className,
    children = props.children,
    label = props.label;
  var t = useLang();
  return React.createElement(My.Banner, null, React.createElement(My.IconHeader, {
    colors: {
      fill: 'strong',
      text: 'strong'
    },
    iconSize: 55,
    reverse: true,
    iconComponent: AiLowerCaseIconGlyph
  }, t(label)));
};
ExplorerGptBannerLayout.defaultProps = ExplorerGptBannerLayoutDefaultProps;
ExplorerGptBannerLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;